import { render } from "./ClientWorkspaceHeader.vue?vue&type=template&id=32c24af0&scoped=true"
import script from "./ClientWorkspaceHeader.vue?vue&type=script&lang=js"
export * from "./ClientWorkspaceHeader.vue?vue&type=script&lang=js"

import "./ClientWorkspaceHeader.vue?vue&type=style&index=0&id=32c24af0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32c24af0"]])

export default __exports__